import { Box } from "@mui/material";
import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { CONSTANT, SEO } from "../../../Utils/Constant";
import ComponentHeader from "../Header/ComponentHeader";
import BlogComponent from "../../Common/BlogContainer/BlogComponent";
import { DataContext } from "../../../Context/DataContext";
import {
  decodeHTMLString,
  returnHelmetAsPerParameter,
} from "../../../Utils/CommonFunction";
import ScientificCalc from "../../Pages/ScientificCalc/ScientificCalc";
import SimilarCalc from "../../Common/SimilarCalc/SimilarCalc";

const ScientificCalculator = () => {
  const { blogData } = useContext(DataContext);
  return (
    <>
      {blogData.yoast_head ? (
        returnHelmetAsPerParameter(blogData)
      ) : (
        <Helmet>
          <title>
            {blogData?.title?.rendered || SEO.SCIENTIFIC_CALC_TITLE}
          </title>
          <meta
            name="description"
            content={
              decodeHTMLString(blogData?.description) ||
              SEO.SCIENTIFIC_CALC_DESCRIPTION
            }
          />
          <meta
            name="keywords"
            content={blogData?.keys?.join(" ") || SEO.SCIENTIFIC_CALC_KEYWORDS}
          />

          <meta
            property="og:title"
            content={blogData?.title?.rendered || SEO.SCIENTIFIC_CALC_TITLE}
          />
          <meta
            property="og:description"
            content={
              decodeHTMLString(blogData?.description) ||
              SEO.SCIENTIFIC_CALC_DESCRIPTION
            }
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content={CONSTANT.CALCULATOR_TIMES_WEB_LINK + blogData?.slug}
          />
          <meta property="og:site_name" content={CONSTANT.CALCULATOR_TIMES} />

          <meta
            name="twitter:title"
            content={blogData?.title?.rendered || SEO.SCIENTIFIC_CALC_TITLE}
          />
          <meta
            name="twitter:description"
            content={
              decodeHTMLString(blogData?.description) ||
              SEO.SCIENTIFIC_CALC_DESCRIPTION
            }
          />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
      )}

      <Box sx={{ p: { xs: "8px 16px", md: "10px 24px" } }}>
        <ComponentHeader />
        <ScientificCalc />
        <SimilarCalc />
        <BlogComponent />
      </Box>
    </>
  );
};

export default ScientificCalculator;
